// extracted by mini-css-extract-plugin
module.exports = {"sameLine":"styles_sameLine__1cy_n","topMargin":"styles_topMargin__sCwPO"};